import React from 'react'
import { Link } from 'react-router-dom'
import { FileQuestion } from 'lucide-react'
import { Button } from '@/components/ui'
import { ROUTES } from '@/router/routes'

/**
 * NotFoundPage (404)
 *
 * Displayed when user navigates to a route that doesn't exist.
 */
const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 bg-slate-200 rounded-full flex items-center justify-center">
            <FileQuestion className="w-12 h-12 text-slate-400" />
          </div>
        </div>

        <h1 className="text-4xl font-bold text-slate-900 mb-2">404</h1>
        <h2 className="text-2xl font-semibold text-slate-700 mb-4">
          Page Not Found
        </h2>
        <p className="text-slate-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="space-y-3">
          <Link to={ROUTES.SOCIAL_MEDIA}>
            <Button variant="primary" className="w-full">
              Go to Dashboard
            </Button>
          </Link>

          <Link to={ROUTES.HOME}>
            <Button variant="ghost" className="w-full">
              Go to Home
            </Button>
          </Link>
        </div>

        <div className="mt-8 text-sm text-slate-500">
          <p>Common pages:</p>
          <div className="flex flex-wrap justify-center gap-3 mt-2">
            <Link to={ROUTES.SOCIAL_MEDIA} className="text-avi-primary hover:underline">
              Social Media
            </Link>
            <span>•</span>
            <Link to={ROUTES.NEWSLETTER} className="text-avi-primary hover:underline">
              Newsletter
            </Link>
            <span>•</span>
            <Link to={ROUTES.REPORTS} className="text-avi-primary hover:underline">
              Reports
            </Link>
            <span>•</span>
            <Link to={ROUTES.SETTINGS} className="text-avi-primary hover:underline">
              Settings
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
